import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import theme from './UserDetailsItem.scss';

const propTypes = {
  message: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  isPhoneNumber: PropTypes.bool,
  value: PropTypes.string,
  valueHandler: PropTypes.func,
};

const defaultProps = {
  isPhoneNumber: false,
  value: '',
  valueHandler: (value) => value,
};

const UserDetailsItem = ({
  message,
  value,
  isPhoneNumber,
  valueHandler,
}) => {
  if (!value) return null;
  return (
    <div className={ theme.item }>
      <div className={ theme.itemTitle }>
        <Choose>
          <When condition={ typeof message === 'object' }>
            <FormattedMessage { ...message } />
          </When>
          <Otherwise>
            { message }
          </Otherwise>
        </Choose>
      </div>
      <div
        className={ classnames(theme.value, {
          [theme.phoneNumber]: isPhoneNumber,
        }) }
      >
        { valueHandler
          ? valueHandler(value)
          : value
        }
      </div>

    </div>
  );
};

UserDetailsItem.propTypes = propTypes;
UserDetailsItem.defaultProps = defaultProps;

export default UserDetailsItem;
